import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nopol Tujuan", -1)
const _hoisted_4 = { class: "invalid-feedback" }
const _hoisted_5 = { style: {"min-height":"30vh"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Nopol", -1)
const _hoisted_10 = { class: "pl-4 text-sm font-normal" }
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Trayek Sekarang", -1)
const _hoisted_13 = { class: "pl-4 text-sm font-normal" }
const _hoisted_14 = { class: "mb-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Kelas", -1)
const _hoisted_16 = { class: "pl-4 text-sm font-normal" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Jam Keberangkatan PP", -1)
const _hoisted_19 = { class: "pl-4" }
const _hoisted_20 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_21 = { class: "w-full mb-3 md:w-1/4 md:mb-0" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_23 = { class: "w-full mb-3 md:w-3/4 md:mb-0" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Review Data Mutasi Bus")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectFetch = _resolveComponent("SelectFetch")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.nextPage,
        "validation-schema": _ctx.schema,
        "initial-values": _ctx.initialValue,
        class: "form-container"
      }, {
        default: _withCtx(({ errors, values, setFieldValue, meta }) => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_Field, { name: "SecondBus" }, {
              default: _withCtx(({ field }) => [
                _createVNode(_component_SelectFetch, _mergeProps(field, {
                  modelValue: field.value,
                  placeholder: 'Pilih Bus',
                  inputId: "busInput",
                  endpoint: "/management/v1/MsVehicle",
                  searchCustom: [['activeOnly', '=', true], ['orderByHasTrayek', '=', true]],
                  selectable: (v) => v.Trayek,
                  fieldLabel: (v) => v.Nopol,
                  clearable: false,
                  searchFields: ['nopol'],
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => _ctx.setCurrVehicleInfo(val))
                }), null, 16, ["modelValue", "selectable", "fieldLabel"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, _toDisplayString(errors.SecondBus), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.selectedBusDetail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.selectedBusDetail.Nopol), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.selectedBusDetail.TrayekDetail ? _ctx.selectedBusDetail.TrayekDetail?.Trayek.Name : 'Tidak Ada'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.selectedBusDetail.TrayekDetail ? _ctx.selectedBusDetail.TrayekDetail?.Trayek.MsClass.Name : 'Tidak Ada'), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      (_ctx.selectedBusDetail.TrayekDetail?.TrayekSubs.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _hoisted_18,
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedBusDetail.TrayekDetail?.TrayekSubs, (data) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    style: {"list-style-type":"disc","list-style-position":"inside"},
                                    key: data
                                  }, _toDisplayString(`${data.DepartureTime.slice(0, 5)} (PP ${data.Order})`), 1))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_Button, {
                class: "btn-back w-full mr-2",
                onClick: _ctx.prevPage
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_Button, {
                class: "btn-primary w-full mr-1",
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "initial-values"])
    ])
  ]))
}